'use es6';

import { basicSelector } from 'ContentEditorUI/redux/selectors/helpers';
import { createSelector } from 'reselect';
import { getContentModelId, getContentModelHtmlTitle, getContentModelMetaDescription, getContentModelFeaturedImage } from 'ContentEditorUI/redux/selectors/baseContentModelSelectors';
import { getPostSettingsFullUrl } from './postSettingsSelectors';
import { getContentModelContentGroupId } from './postContentModelSelectors';
export const getSocialComposerOpen = basicSelector(state => state.socialComposer.get('open'));
export const getSocialComposerParams = basicSelector(state => state.socialComposer.get('params'));
export const getPublishSocialComposerParams = createSelector(getContentModelId, getContentModelHtmlTitle, getContentModelMetaDescription, getContentModelFeaturedImage, getPostSettingsFullUrl, getContentModelContentGroupId, (id, title, description, featuredImage, url, contentGroupId) => {
  return {
    id,
    title,
    description,
    featuredImage,
    url,
    contentGroupId
  };
});